export default __webpack_public_path__ + "static/media/ic-offline.1f16e80c.svg";